import React, { useEffect, useState } from "react";
import useHttp from "../../hooks/use-http";
import { useSelector } from "react-redux";
import { endPoints } from "../../config/end-points";





const AIdivEditor = () => {

//   const { toggleRightshow } = props;
//   const dispatch = useDispatch();

//   const single_layer = useSelector((state) => state.campaign.single_layer);
  const {sendRequest: generateQuotes} = useHttp();
  const [quotesResults, setQuotesResults] = useState({});
  const [showAiQuotes, setShowAiQuotes] = useState(false);
  const [available, setAvailable] = useState(0);
//   const [searchImageResults, setSearchImageResults] = useState({});

const editSlideData = useSelector((state) => state.campaign.editSlideData);
const [promt, setPromt] = useState("");


  

  useEffect(() => {
    if(editSlideData){

        const dataArray = Object.entries(editSlideData);
        let quotes = '';

        dataArray.map(([key, value]) => {
            
          if(key && key.includes("author_")){
            quotes += value+' ';
          }

          return null;
        });

        quotes = "Generate 10 '"+quotes+"' quotes within 15 words";
        setPromt(quotes);
        // console.log(quotes);

    }
  }, [editSlideData ]);
  
  const promthandle = (data) => {

    // console.log(data.target.value);
    setPromt(data.target.value);
  }

  const getQuotes = async () => {
    
    generateQuotes(
      {
        url: endPoints.genQuote,
        method: "POST",
        body: {
          promt: promt ,
          max_tokens: 100
        }
      },
      async (response) => {
        // console.log(response.split('\n').filter(Boolean));
        setAvailable(2);
        setShowAiQuotes(true);
        setResult(await response.split('\n').filter(Boolean));
      }
    );
  };

  const setResult = (data)=>{
    console.log(data);
    setQuotesResults(data)
  }

  const handleCopyText = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <>
      <div className="row">
          <div className="col-md-12 px-3 text-align-left">
            <div className="mb-3">
              <label className="form-label"><b>Prompt</b></label>
              <textarea type="text" placeholder="Enter Json Data" className="form-control AiPromptDiv" value={promt} onChange={(e) => promthandle(e)} >
              </textarea>
            </div>
          </div>

        <div className="d-flex flex-right px-3 pt-2">
          <div className="input-group justify-content-end ">
            
            <button
              className="btn btn-outline-secondary shadow-none p-2"
              type="button"
              id="button-addon2"
              onClick={getQuotes}
            >
              Generate Quote
            </button>
          </div>
        </div>
        
      </div>

      <div className="row mt-4">
          {showAiQuotes && (
            <div className="container">
              <div className="" style={{ height: "235px", overflow: 'scroll' }}>
                {available === 2 && (
                  <ul>

                    {quotesResults &&
                      quotesResults.map(
                        ( item, index) => (
                          <li className="px-3 quote" key={index}>
                            {item}
                            <button
                            className="btn btn-sm p-1 m-2 cpbtn" style={{fontSize: 'small'}}
                            //   onClick={(e) => updateNewData(e, url)}
                            onClick={ () => handleCopyText(item)}
                            >
                              <span >Copy</span>
                            </button>
                          </li>
                        )
                      )
                    }
                  </ul>
                )}

              </div>
              
            </div>
          )}
        </div>
    </>
  );
};

export default AIdivEditor;
